"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContextSeoInfo = void 0;
const getContextSeoInfo = () => {
    let contextSeoMeta = "";
    let pageName = "";
    let pageProductName = "";
    try {
        contextSeoMeta = document.querySelector('meta[id="context_seo_meta"]').getAttribute("content");
    }
    catch (error) { }
    try {
        pageName = document.querySelector('meta[id="page_name"]').getAttribute("content");
    }
    catch (error) { }
    try {
        pageProductName = document.querySelector('meta[id="product_name"]').getAttribute("content");
    }
    catch (error) { }
    const res = {
        contextSeoMeta,
        pageName,
        pageProductName,
    };
    return res;
};
exports.getContextSeoInfo = getContextSeoInfo;
exports.default = exports.getContextSeoInfo;
//# sourceMappingURL=index.js.map